<mat-progress-bar
  mode="indeterminate"
  class="progress-bar"
  [class.visible]="isNavigating()"
/>
